<template>
    <div>
        <el-table v-loading="tableLoading"
                  :data="tableData"
                  border
                  style="width: 100%"
                  :header-cell-style="{ backgroundColor: '#347CAF', textAlign: 'center',color: '#fff', fontSize: '14px', fontWeight: 'bold' }"
                  :cell-style="{ textAlign: 'center', padding: '0px' }">
            <el-table-column type="index"
                             width="60"
                             label="序号">
                <template slot-scope="scope">
                    <template v-if="scope.$index <= 2 && $parent.listPagin.page == 1">
                        <img v-if="scope.$index == 0"
                             src="@/assets/common/rank/1.gif">
                        <img v-if="scope.$index == 1"
                             src="@/assets/common/rank/2.gif">
                        <img v-if="scope.$index == 2"
                             src="@/assets/common/rank/3.gif">
                    </template>
                    <template v-else>
                        {{scope.$index + 1 + ($parent.listPagin.page - 1) * 10}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="number"
                             label="期号"
                             width="80" />
            <el-table-column prop="nickName"
                             label="缩水师">
                <template slot-scope="scope">
                    <div @click="view_history(scope.row,'pls')"
                         style="cursor: pointer;color: #347CAF;font-weight: bold;">
                        {{scope.row.nickName}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="preIndexSix"
                             label="800-899注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexSix,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexSix,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexSix,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexSix,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexSix,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'5','800-899注','preIndexSix')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'800-899注','preIndexSix')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="preIndexEightyw"
                             :show-overflow-tooltip="true"
                             label="700-799注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexEightyw,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexEightyw,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexEightyw,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexEightyw,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexEightyw,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'0','700-799注','preIndexEightyw')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'700-799注','preIndexEightyw')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="preIndexFiftyw"
                             :show-overflow-tooltip="true"
                             label="400-599注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexFiftyw,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexFiftyw,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexFiftyw,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexFiftyw,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexFiftyw,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'1','400-599注','preIndexFiftyw')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'400-599注','preIndexFiftyw')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="preIndexFifteenw"
                             :show-overflow-tooltip="true"
                             label="200-399注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexFifteenw,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexFifteenw,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexFifteenw,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexFifteenw,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexFifteenw,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'2','200-399注','preIndexFifteenw')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'200-399注','preIndexFifteenw')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="preIndexFourw"
                             :show-overflow-tooltip="true"
                             label="50-199注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexFourw,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexFourw,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexFourw,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexFourw,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexFourw,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'3','50-199注','preIndexFourw')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'50-199注','preIndexFourw')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="preIndexFivek"
                             :show-overflow-tooltip="true"
                             label="1-49注">
                <template slot-scope="scope">
                    <div>
                        {{ showPriceWord(scope.row.preIndexFivek,'real_bet_number') }}注
                        <b style="color:green"
                           v-if="showPriceWord(scope.row.preIndexFivek,'is_win') == '是'">是</b>
                        <span v-else>{{showPriceWord(scope.row.preIndexFivek,'is_win')}}</span>
                        <el-tag type="success"
                                :class="{ toll:showPriceWord(scope.row.preIndexFivek,'free') }"
                                size="mini">{{ showPriceWord(scope.row.preIndexFivek,'coin') }}</el-tag>
                    </div>
                    <el-button @click="handleDownload(scope.row,'4','1-49注','preIndexFivek')"
                               type="text"
                               size="small">下载</el-button>
                    <el-button @click="preDetail(scope.row,'1-49注','preIndexFivek')"
                               type="text"
                               size="small">查看详情</el-button>
                </template>
            </el-table-column>

        </el-table>
        <showDetail ref="showDetail" />
    </div>
</template>

<script>
import tableMixin from './mixin'
export default {
    props: ['tableData'],
    mixins: [tableMixin]
}
</script>

<style lang="scss" scoped>
.toll {
    background-color: #ff4d00 !important;
    // background-color: #D84315!important;
    color: #fff !important;
    border: 0 !important;
}
.el-tag {
    display: block;
    width: fit-content;
    margin: 10px auto 5px;
    color: #347caf;
    background-color: #93d2f3;
    font-weight: bold;
}
</style>